<header>
  <app-header></app-header>
  <app-navbar></app-navbar>
</header>
<body>
  <div class="card">
    <div class="card-header text-center" style="background-color: #be0c4d;">
      <h5 style="color: white;">Administración Información - Cargue Masivo CHV</h5>
    </div>
    <div class="card-body">
      <div class="btn-toolbar" role="toolbar" aria-label="Toolbar with button groups">
        <button type="button" class="btn btn-secondary" (click)="RegresarAdminChv()">Volver</button>
        <button type="button" class="btn btn-primary" style="margin-left: 3px;" (click)="RealizarCargueMasivoSupersolidaria()">Supersolidaria</button>
      </div>
      <div class="justify-content-md-center overflow-scroll">
        <table datatable [dtOptions]="dtOptions"  [dtTrigger]="dtTrigger" class="table table-bordered row-border hover datatable"
         id="table2excel">
          <thead>
            <tr>
              <th scope="col" class="text-center">NIT</th>
              <th scope="col" class="text-center">Razón Social</th>
              <th scope="col" class="text-center">Departamento</th>
              <th scope="col" class="text-center">Municipo</th>
              <th scope="col" class="text-center">Cargar información</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let fuente of fuentesChv">
              <td scope="col">{{fuente.nit}}</td>
              <td scope="col">{{fuente.nombEntidad}}</td>
              <td scope="col">{{fuente.depto}}</td>
              <td scope="col">{{fuente.muni}}</td>
              <td  class="text-center">
                <a type="button" class="fas fa-upload" style="color: green;" (click)="RealizarCargueMasivo(fuente.id)"></a>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>



  <div style="display: none;">
    <table class="table table-responsive" id="ErroresCargue">
      <thead>
        <tr>
          <td>CONSECUTIVO</td>
          <td>ANIO</td>
          <td>TRIMESTRE</td>
          <td>CODIGO ENTIDAD</td>
          <td>TIPO DE CREDITO</td>
          <td>DEPARTAMENTO</td>
          <td>MUNICIPIO</td>
          <td>SOLUCION VIVIENDA</td>
          <td>TENEDOR</td>
          <td>MONEDA</td>
          <td>RANGO VIVIENDA</td>
          <td>MORA</td>
          <td>NUMERO DE CREDITOS</td>
          <td>SALDO CAPITAL TOTAL</td>
          <td>CAPITAL DE 1 O MAS CUOTAS VENCIDAS</td>
          <td>TASA</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let error of RespuestaCargue.contenido">
          <td>{{error.consecutivo}}</td>
          <td>{{error.anio}}</td>
          <td>{{error.trimestre}}</td>
          <td>{{error.codigo_entidad}}</td>
          <td>{{error.tipo_de_credito}}</td>
          <td>{{error.departamento}}</td>
          <td>{{error.municipio}}</td>
          <td>{{error.solucion_vivienda}}</td>
          <td>{{error.tenedor}}</td>
          <td>{{error.moneda}}</td>
          <td>{{error.rango_vivienda}}</td>
          <td>{{error.mora}}</td>
          <td>{{error.numero_creditos}}</td>
          <td>{{error.saldo_capital_total}}</td>
          <td>{{error.capital_una_mas_cuotas_vencidad}}</td>
          <td>{{error.tasa}}</td>
        </tr>
      </tbody>
    </table>
  </div>

  <div style="display: none;">
    <table class="table table-responsive" id="ErroresCargueSuper">
      <thead>
        <tr>
          <td>CONSECUTIVO</td>
          <td>ANIO</td>
          <td>TRIMESTRE</td>
          <td>CODIGO TIPO ENTIDAD</td>
          <td>CODIGO ENTIDAD</td>
          <td>TIPO DE CREDITO</td>
          <td>DEPARTAMENTO</td>
          <td>MUNICIPIO</td>
          <td>SOLUCION VIVIENDA</td>
          <td>TENEDOR</td>
          <td>MONEDA</td>
          <td>RANGO VIVIENDA</td>
          <td>MORA</td>
          <td>NUMERO DE CREDITOS</td>
          <td>SALDO CAPITAL TOTAL</td>
          <td>CAPITAL DE 1 O MAS CUOTAS VENCIDAS</td>
          <td>TASA</td>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let error of RespuestaCargue.contenido">
          <td>{{error.consecutivo}}</td>
          <td>{{error.anio}}</td>
          <td>{{error.trimestre}}</td>
          <td>{{error.cod_tipo_entidad}}</td>
          <td>{{error.codigo_entidad}}</td>
          <td>{{error.tipo_de_credito}}</td>
          <td>{{error.departamento}}</td>
          <td>{{error.municipio}}</td>
          <td>{{error.solucion_vivienda}}</td>
          <td>{{error.tenedor}}</td>
          <td>{{error.moneda}}</td>
          <td>{{error.rango_vivienda}}</td>
          <td>{{error.mora}}</td>
          <td>{{error.numero_creditos}}</td>
          <td>{{error.saldo_capital_total}}</td>
          <td>{{error.capital_una_mas_cuotas_vencidad}}</td>
          <td>{{error.tasa}}</td>
        </tr>
      </tbody>
    </table>
  </div>

</body>

<!--REALIZAR CARGUE MASIVO PARA LA FUENTE-->
<button class="btn btn-primary btn-sm" #OpenModalCargueMasivo data-toggle="modal"  data-target="#fichaindividial" style="visibility: hidden;" data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-xl" id="fichaindividial" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h4 style="color: white;">Cargue masivo - {{FuenteCargueM.nombEntidad}}</h4>
        <button type="button" class="close"  aria-label="Close"  (click)="CerrarModalCargueFuente()">
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row" style="margin: 5px;">
            <div class="col-6">
              <div class="row"><b>Razón social</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="razonsocialfichaind" [(ngModel)]="FuenteCargueM.nombEntidad" disabled/></div>
            </div>
            <div class="col-2">
              <div class="row"><b>NIT</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="nit" [(ngModel)]="FuenteCargueM.nit" disabled/></div><!---->
            </div>
            <div class="col-2">
              <div class="row"><b>Código entidad</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="codigoenti" [(ngModel)]="FuenteCargueM.codEnti" disabled/></div><!---->
            </div>
            <div class="col-auto" style="margin: auto;">
              <div class="col-1">
                <a id="botonpdf" class="btn btn-light" data-bs-toggle="tooltip" title="Instructivo" [href]="pdfUrl" download></a>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 3px;">
            <div class="col-1" style="text-align: center;">
              <label style="margin-top: 4px;"><b>Periodo :</b></label>
            </div>
            <div class="col-auto">
              <select class="form-select" aria-label="Default select example" name="periodo" (change)="ConsultarExisteReporte($event.target.value)">
                <option  value="" selected="selected">Seleccionar</option>
                <option *ngFor="let p of PeriodosConsultar" value="{{p.id}}">{{p.anio}} - {{p.consecutivoPeriodo}}</option>
              </select>
            </div>
          </div>
          <div>
            <div class="row" style="margin-top: 3px; margin-left: 10px;">
              <b>Ingrese las observaciones para realizar el cargue</b>
            </div>
            <div style="text-align: center;">
               <textarea class="form-control col-11" name="observacionaprobador" rows="4" style="margin: auto; margin-top: 3px;" [(ngModel)]="ObservacionCargue" maxlength="500"></textarea>
            </div>
            <br>
            <div class="row align-items-center col-10" style="border: dashed; border-color: grey; margin: auto; min-width: 500px;">
              <div class="col-10">
                <div class="custom-file">
                  <form enctype="multipart/form-data">
                    <input type="file" class="form-control" placeholder="Archivo" accept=".xlsx, .xls" (change)="uploadFile($event)">
                  </form>
                </div>
              </div>
              <div class="col-1">
                <a id="boton" class="btn btn-light" data-bs-toggle="tooltip" title="Plantilla" [href]="xlsxUrl" download></a>
              </div>
              <br>
              <div *ngIf="!BtnCargarArchivo" class="row">
                <button class="btn btn-secondary col-auto" style="margin: auto; margin-block: 10px;" [disabled]="BtnCargarArchivo" (click)="VerificarDocumentoCargue()">Cargar archivo</button><!-- -->
              </div>
              <div *ngIf="CargueExitoso" class="row" style="text-align: center;" ><!---->
                <h5 style="color: darkblue;">Cargue exitoso!</h5>
              </div>
              <div *ngIf="ErrorCargue" class="row" style="text-align: center;"><!---->
                <p style="color: #be0c4d;">Error en el cargue, por favor verifiqueen el siguiente link:</p>
                <a type="button" class="btn btn-link" id="exportar"style="color: lightseagreen; margin-block: 10px;" (click)="download()">Verificar Cargue</a>
              </div>
            </div>
            <div *ngIf="CargueExitoso" class="row"><!---->
              <button class="btn btn-secondary col-auto" style="margin: auto; margin-block: 10px" [disabled]="BtnConfirmarCargue" (click)="ConfirmarCargue()">Confirmar cargue</button><!-- -->
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer justify-content-md-center" style="visibility: hidden;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" #CloseModalCargueMasivo style="visibility: hidden;">Close</button>
      </div>
    </div>
  </div>
</div>



<!--REALIZAR CARGUE MASIVO PARA SUPERSOLIDARIA-->
<button class="btn btn-primary btn-sm" #OpenModalCargueMasivoSuper data-toggle="modal"  data-target="#carguesupersoli" style="visibility: hidden;" data-backdrop="static">ModCargar</button>
<div class="modal fade bd-example-modal-xl" id="carguesupersoli" tabindex="-1" role="dialog" aria-labelledby="myLargeModalLabel" aria-hidden="true">
  <div class="modal-dialog modal-xl">
    <div class="modal-content">
      <div class="modal-header" style="background-color: #be0c4d;">
        <h4 style="color: white;">Cargue masivo - Supersolidaria</h4>
        <button type="button" class="close"  aria-label="Close" data-dismiss="modal"><!--(click)="CerrarModalCargueFuente()"-->
          <span aria-hidden="true"><i class="fas fa-times" style="color: white;"></i></span>
        </button>
      </div>
      <div class="modal-body">
        <form>
          <div class="row" style="margin: 5px;">
            <div class="col-6">
              <div class="row"><b>Razón social</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="razonsocial"  disabled/></div>
            </div>
            <div class="col-2">
              <div class="row"><b>NIT</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="nit"  disabled/></div><!---->
            </div>
            <div class="col-2">
              <div class="row"><b>Código entidad</b></div>
              <div class="row"style="margin-right: 5px;"><input class="form-control" type="text" name="codigo"  disabled/></div><!---->
            </div>
            <div class="col-auto" style="margin: auto;">
              <div class="col-1">
                <a id="botonpdf" class="btn btn-light" data-bs-toggle="tooltip" title="Instructivo" [href]="pdfUrl" download></a>
              </div>
            </div>
          </div>
          <div class="row" style="margin-top: 3px;">
            <div class="col-1" style="text-align: center;">
              <label style="margin-top: 4px;"><b>Periodo :</b></label>
            </div>
            <div class="col-auto">
              <select class="form-select" aria-label="Default select example" name="periodo" (change)="ConsultarExisteReporteSuper($event.target.value)"><!-- -->
                <option  value="" selected="selected">Seleccionar</option>
                <option *ngFor="let p of PeriodosConsultar" value="{{p.id}}">{{p.anio}} - {{p.consecutivoPeriodo}}</option>
              </select>
            </div>
          </div>
          <div>
            <div class="row" style="margin-top: 3px; margin-left: 10px;">
              <b>Ingrese las observaciones para realizar el cargue</b>
            </div>
            <div style="text-align: center;">
               <textarea class="form-control col-11" name="observacionaprobador" rows="4" style="margin: auto; margin-top: 3px;" disabled></textarea><!---->
            </div>
            <br>
            <div class="row align-items-center col-10" style="border: dashed; border-color: grey; margin: auto; min-width: 500px;">
              <div class="col-10">
                <div class="custom-file">
                  <form enctype="multipart/form-data">
                    <input type="file" class="form-control" placeholder="Archivo" accept=".xlsx, .xls" (change)="uploadFile($event)">
                  </form>
                </div>
              </div>
              <div class="col-1">
                <a id="boton" class="btn btn-light" data-bs-toggle="tooltip" title="Plantilla" [href]="xlsxUrlSuper" download></a>
              </div>
              <br>
              <div *ngIf="!BtnCargarArchivoSuper" class="row">
                <button class="btn btn-secondary col-auto" style="margin: auto; margin-block: 10px;" [disabled]="BtnCargarArchivoSuper" (click)="VerificarDocumentoCargueSuper()">Cargar archivo</button><!-- -->
              </div>
              <div *ngIf="CargueExitosoSuper" class="row" style="text-align: center;" ><!---->
                <h5 style="color: darkblue;">Cargue exitoso!</h5>
              </div>
              <div *ngIf="ErrorCargueSuper" class="row" style="text-align: center;"><!---->
                <p style="color: #be0c4d;">Error en el cargue, por favor verifiqueen el siguiente link:</p>
                <a type="button" class="btn btn-link" id="exportar"style="color: lightseagreen; margin-block: 10px;" (click)="download2()">Verificar Cargue</a>
              </div>
            </div>
            <div *ngIf="CargueExitosoSuper" class="row"><!---->
              <button class="btn btn-secondary col-auto" style="margin: auto; margin-block: 10px" [disabled]="BtnConfirmarCargueSuper" (click)="ConfirmarCargueSuper()">Confirmar cargue</button><!-- -->
            </div>
          </div>
        </form>
      </div>
      <div class="modal-footer justify-content-md-center" style="visibility: hidden;">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" #CloseModalCargueMasivoSuper style="visibility: hidden;">Close</button>
      </div>
    </div>
  </div>
</div>

